<template>
	<header class="bg-white">
		<div class="flex w-full flex-col gap-8 px-5 pb-[60px] pt-6 2xl:px-32">
			<div>
				<Breadcrumb :items="breadcrumbItems" />
			</div>
			<div>
				<h1
					class="font-matter-sq text-2xl font-normal leading-[150%] tracking-[-0.72px] text-primary md:text-4xl"
				>
					Sua privacidade é nossa prioridade
				</h1>
				<h2 class="text-base leading-[150%] text-primary md:text-lg">
					Entenda como coletamos, usamos e protegemos suas informações.
				</h2>
			</div>
		</div>
	</header>
	<article class="min-h-screen bg-white-dark-1! px-6 py-[60px] 2xl:px-0">
		<Container
			class="h-full max-w-4xl bg-white! shadow-[0px_1px_3px_1px_rgba(0,0,0,0.15)]"
		>
			<iframe
				src="/termos/politica-de-privacidade"
				class="h-screen w-full"
			></iframe>
		</Container>
	</article>
</template>

<script setup lang="ts">
import { defaultTwitterCardMeta } from '@/constants/seo';
import { useAbsoluteUrl } from '~/composables/useAbsoluteUrl';

const { toAbsoluteUrl } = useAbsoluteUrl();
const ogImageUrl = toAbsoluteUrl('/images/social/openGraph/og_home.webp');

useSeoMeta({
	title: 'Política de Privacidade | PilarHomes',
	description:
		'Sua privacidade é nossa prioridade. Entenda como protegemos seus dados e garantimos a segurança das suas informações no PilarHomes.',
	keywords: 'privacidade, dados, PilarHomes',
	ogTitle: 'Política de Privacidade | PilarHomes',
	ogDescription:
		'Sua privacidade é nossa prioridade. Entenda como protegemos seus dados e garantimos a segurança das suas informações no PilarHomes.',
	ogImage: ogImageUrl,
	twitterCard: defaultTwitterCardMeta,
	twitterTitle: 'Política de Privacidade | PilarHomes',
	twitterDescription:
		'Sua privacidade é nossa prioridade. Entenda como protegemos seus dados e garantimos a segurança das suas informações no PilarHomes.',
	twitterImage: ogImageUrl
});

const breadcrumbItems = [
	{ label: 'Início', route: '/' },
	{
		label: 'Política de privacidade',
		route: '/politica-de-privacidade'
	}
];

const route = useRoute();
const { $mixpanel } = useNuxtApp();

onMounted(() => {
	$mixpanel.track('page_viewed', {
		current_page: route.fullPath,
		previous_page_url: document.referrer,
		event_name: 'page_viewed'
	});
});
</script>
